module.exports = __webpack_public_path__ + "media/images/icons/search-blue-a97f2ccc2e5181ed6102cf9c20d88a12.svg";